var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#47494D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 18.2C12.5 15.052 15.052 12.5 18.2 12.5H27.8C30.948 12.5 33.5 15.052 33.5 18.2V27.8C33.5 30.948 30.948 33.5 27.8 33.5H18.2C15.052 33.5 12.5 30.948 12.5 27.8V18.2ZM18.2 14.3C16.0461 14.3 14.3 16.0461 14.3 18.2V27.8C14.3 29.9539 16.0461 31.7 18.2 31.7H27.8C29.9539 31.7 31.7 29.9539 31.7 27.8V18.2C31.7 16.0461 29.9539 14.3 27.8 14.3H18.2Z",
    fill: "#F3F5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1 17.9C18.4372 17.9 17.9 18.4373 17.9 19.1C17.9 19.7627 18.4372 20.3 19.1 20.3C19.7627 20.3 20.3 19.7627 20.3 19.1C20.3 18.4373 19.7627 17.9 19.1 17.9ZM16.1 19.1C16.1 17.4432 17.4431 16.1 19.1 16.1C20.7568 16.1 22.1 17.4432 22.1 19.1C22.1 20.7569 20.7568 22.1 19.1 22.1C17.4431 22.1 16.1 20.7569 16.1 19.1Z",
    fill: "#F3F5FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0198 23.5655C28.4097 22.8029 27.2452 22.8174 26.6542 23.5949L24.1418 26.9007C23.1096 28.2589 21.2122 28.6065 19.7655 27.7023L18.442 26.8751C17.8497 26.5049 17.0802 26.5925 16.5863 27.0864L14.0363 29.6364L12.7635 28.3636L15.3135 25.8136C16.4001 24.7271 18.0929 24.5343 19.396 25.3487L20.7195 26.1759C21.3771 26.5869 22.2395 26.4289 22.7088 25.8115L25.2211 22.5058C26.5212 20.7952 29.0832 20.7633 30.4253 22.4411L33.3027 26.0378L31.8972 27.1622L29.0198 23.5655Z",
    fill: "#F3F5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/img-icon.fe8651f625510ffd5dedec31f39f77da.svg";
export { ForwardRef as ReactComponent };